import * as React from 'react';
import styled from 'styled-components';
import {CardTitle, P1, P2} from "../Kit/Kit";

const Container = styled.div`
    h1, p {
      text-align: left;
    }
    
    display: grid;
    grid-row-gap: 16px;
    
    @media(min-width: 992px){
      grid-row-gap: 34px;
    }
    
    @media(min-width: 1680px){
      grid-row-gap: 68px;
    }
    
    order: 2;
`;

const DescriptionContainer = styled.div`
  display: grid;
  grid-row-gap: 8px;
  
  @media(min-width: 992px) {
    grid-row-gap: 24px;
  }
`;

const MissionContainer = DescriptionContainer.extend``;

const MissionTitle = P1.extend`
    color: #004a87;
    font-family: Cabin-Bold, sans-serif;
`;

const AffiliateText = (props) => {
    const {name, description, acronym, mission_text} = props.affiliate;
    return (
      <Container>
          <DescriptionContainer>
              <CardTitle>{name}</CardTitle>
              <P2
                dangerouslySetInnerHTML={{__html: description}}
              />
          </DescriptionContainer>
          <MissionContainer>
              <MissionTitle>{acronym}'s Mission</MissionTitle>
              <P2
                dangerouslySetInnerHTML={{__html: mission_text}}
              />
          </MissionContainer>
      </Container>
    );
};

export default AffiliateText;


// WEBPACK FOOTER //
// ./src/components/Affiliations/AffiliateText.js